import { createUseStyles } from 'react-jss';

import { MD_MEDIA_QUERY } from '~shared/media-query';
import { PricingAppTheme } from '~app/styles/pricing/types';

export default createUseStyles(({ spacing, type, pricingPalette }: PricingAppTheme) => ({
  FeatureItemOverride: {
    position: 'relative',
    padding: [6, '20%'],
    display: 'flex',
    alignItems: 'center',
    wordBreak: 'break-word',
    '&:before': {
      content: '"•"',
      display: 'inline-block',
      paddingRight: 10,
      color: pricingPalette.colors.stone,
      fontSize: 20,
      flex: 1,
      alignSelf: 'flex-start',
      lineHeight: 0.9,
    },

    '&:nth-child(-n+2)': {
      '&:before': {
        visibility: 'hidden',
      },
    },

    [MD_MEDIA_QUERY]: {
      padding: `6px ${spacing[7]}px 6px ${spacing[6]}px`,
      '&:hover': {
        extend: 'Highlight',
        transition: '0.2s ease',
      },
    },
  },

  EverythingIn: {
    fontWeight: 'bold',
    padding: [spacing[4], '20%', spacing[2]],
    marginTop: 10,

    '&:hover': {
      background: 'transparent',
    },

    '&:after': {
      content: '""',
      borderTop: '1px solid #D0D2D3',
      position: 'absolute',
      padding: 0,
      top: 0,
      left: spacing[6],
      right: spacing[6],
    },

    [MD_MEDIA_QUERY]: {
      paddingLeft: spacing[6],
      paddingRight: spacing[7],
    },
  },
}));
